import React from 'react'
import { Button, createSvgIcon } from '@material-ui/core'
import BarChartIcon from '@material-ui/icons/BarChart'
import { navigate } from '@reach/router'
import clsx from 'clsx'
import { useSchools } from 'Educators/SchoolsContext'
import { featureEnabled } from 'featureFlags'

const MonitorIcon = createSvgIcon(
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="table_chart">
      <path
        id="Vector"
        d="M10 10.353H15V21.333H10V10.353ZM17 21.333H20C21.1 21.333 22 20.433 22 19.333V10.333H17V21.333ZM20 3.33301H5C3.9 3.33301 3 4.23301 3 5.33301V8.33301H22V5.33301C22 4.23301 21.1 3.33301 20 3.33301ZM3 19.333C3 20.433 3.9 21.333 5 21.333H8V10.333H3V19.333Z"
        fill="currentColor"
      />
    </g>
  </svg>,
  'Monitor',
)

const ManageSchoolIcon = createSvgIcon(
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icon">
      <path
        id="Subtract"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 10.4833V6.66153C15.5 6.1311 15.2893 5.62239 14.9142 5.24731L13.2071 3.54021C12.8166 3.14968 12.1834 3.14968 11.7929 3.54021L10.0858 5.24731C9.71071 5.62239 9.5 6.13109 9.5 6.66153V7.8331H4.5C3.94772 7.8331 3.5 8.28082 3.5 8.8331V20.8331C3.5 21.3854 3.94772 21.8331 4.5 21.8331H13.517C12.9332 21.2585 12.4498 20.5823 12.0954 19.8331H12C11.7239 19.8331 11.5 19.6092 11.5 19.3331V18.3331C11.5 18.2597 11.5158 18.19 11.5443 18.1271C11.4672 17.7111 11.4269 17.2822 11.4269 16.8438C11.4269 16.4001 11.4682 15.966 11.5471 15.5452C11.5169 15.4808 11.5 15.4089 11.5 15.3331V14.3331C11.5 14.057 11.7239 13.8331 12 13.8331H12.1056C12.8094 12.3581 14.0143 11.1681 15.5 10.4833ZM7 19.8331C7.27614 19.8331 7.5 19.6092 7.5 19.3331V18.3331C7.5 18.057 7.27614 17.8331 7 17.8331H6C5.72386 17.8331 5.5 18.057 5.5 18.3331V19.3331C5.5 19.6092 5.72386 19.8331 6 19.8331H7ZM7 15.8331C7.27614 15.8331 7.5 15.6092 7.5 15.3331V14.3331C7.5 14.057 7.27614 13.8331 7 13.8331H6C5.72386 13.8331 5.5 14.057 5.5 14.3331V15.3331C5.5 15.6092 5.72386 15.8331 6 15.8331H7ZM7 11.8331C7.27614 11.8331 7.5 11.6092 7.5 11.3331V10.8331V10.3331C7.5 10.057 7.27614 9.8331 7 9.8331H6C5.72386 9.8331 5.5 10.057 5.5 10.3331V11.3331C5.5 11.6092 5.72386 11.8331 6 11.8331H7ZM13 11.8331C13.2761 11.8331 13.5 11.6092 13.5 11.3331V10.3331C13.5 10.057 13.2761 9.8331 13 9.8331H12C11.7239 9.8331 11.5 10.057 11.5 10.3331V11.3331C11.5 11.6092 11.7239 11.8331 12 11.8331H13ZM13 7.8331C13.2761 7.8331 13.5 7.60924 13.5 7.3331V6.3331C13.5 6.05696 13.2761 5.8331 13 5.8331H12C11.7239 5.8331 11.5 6.05696 11.5 6.3331V7.3331C11.5 7.60924 11.7239 7.8331 12 7.8331H13Z"
        fill="currentColor"
      />
      <path
        id="Vector"
        d="M22.1641 16.833C22.1641 16.7072 22.1543 16.588 22.1403 16.4697C22.1205 16.3028 22.1798 16.1359 22.3056 16.0245L22.9384 15.4639C23.1163 15.3062 23.1587 15.0452 23.0397 14.8394L22.4491 13.8176C22.3299 13.6114 22.0818 13.5179 21.8561 13.5941L21.0612 13.8628C20.8954 13.9188 20.7139 13.8819 20.5718 13.7797C20.3837 13.6445 20.1831 13.5278 19.9702 13.4297C19.8134 13.3575 19.6934 13.2202 19.6593 13.051L19.4949 12.2343C19.4479 12.0009 19.2428 11.833 19.0047 11.833H17.8235C17.5854 11.833 17.3803 12.0009 17.3333 12.2343L17.1689 13.051C17.1348 13.2202 17.0148 13.3575 16.858 13.4297C16.6451 13.5278 16.4445 13.6445 16.2564 13.7797C16.1143 13.8819 15.9328 13.9188 15.767 13.8628L14.9721 13.5941C14.7465 13.5179 14.4983 13.6114 14.3791 13.8176L13.7885 14.8394C13.6696 15.0452 13.7119 15.3062 13.8898 15.4639L14.5226 16.0245C14.6484 16.1359 14.7077 16.3028 14.6879 16.4697C14.6739 16.588 14.6641 16.7072 14.6641 16.833C14.6641 16.9588 14.6739 17.078 14.6879 17.1963C14.7077 17.3632 14.6484 17.5301 14.5226 17.6415L13.8898 18.2022C13.7119 18.3598 13.6696 18.6208 13.7885 18.8266L14.3791 19.8484C14.4983 20.0546 14.7465 20.1481 14.9721 20.0719L15.767 19.8033C15.9328 19.7472 16.1143 19.7841 16.2564 19.8863C16.4445 20.0215 16.6451 20.1382 16.858 20.2363C17.0148 20.3085 17.1348 20.4458 17.1689 20.615L17.3333 21.4317C17.3803 21.6651 17.5854 21.833 17.8235 21.833H19.0047C19.2428 21.833 19.4479 21.6651 19.4949 21.4317L19.6593 20.615C19.6934 20.4458 19.8134 20.3085 19.9702 20.2363C20.1831 20.1382 20.3837 20.0215 20.5718 19.8863C20.7139 19.7841 20.8954 19.7472 21.0612 19.8033L21.8561 20.0719C22.0818 20.1481 22.3299 20.0546 22.4491 19.8484L23.0397 18.8266C23.1587 18.6208 23.1163 18.3598 22.9384 18.2022L22.3056 17.6415C22.1798 17.5301 22.1205 17.3632 22.1403 17.1963C22.1543 17.078 22.1641 16.9588 22.1641 16.833ZM18.4141 18.833C17.3141 18.833 16.4141 17.933 16.4141 16.833C16.4141 15.733 17.3141 14.833 18.4141 14.833C19.5141 14.833 20.4141 15.733 20.4141 16.833C20.4141 17.933 19.5141 18.833 18.4141 18.833Z"
        fill="currentColor"
      />
    </g>
  </svg>,
  'ManageSchool',
)

const DiscoveryIcon = createSvgIcon(
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="Vector"
      d="M22.5 12.333C22.5 6.81301 18.02 2.33301 12.5 2.33301C6.98 2.33301 2.5 6.81301 2.5 12.333C2.5 13.663 2.76 14.943 3.24 16.103L7.85 11.483C8.22 11.113 8.8 11.093 9.2 11.423L11.8 13.613L15.08 10.333H14.5C13.95 10.333 13.5 9.88301 13.5 9.33301C13.5 8.78301 13.95 8.33301 14.5 8.33301H17.5C18.05 8.33301 18.5 8.78301 18.5 9.33301V12.333C18.5 12.883 18.05 13.333 17.5 13.333C16.95 13.333 16.5 12.883 16.5 12.333V11.753L12.56 15.683C12.19 16.053 11.6 16.073 11.21 15.733L8.62 13.543L4.22 17.943C6.02 20.593 9.06 22.333 12.5 22.333H20.5C21.6 22.333 22.5 21.433 22.5 20.333V12.333ZM20 20.833C19.45 20.833 19 20.383 19 19.833C19 19.283 19.45 18.833 20 18.833C20.55 18.833 21 19.283 21 19.833C21 20.383 20.55 20.833 20 20.833Z"
      fill="currentColor"
    />
  </svg>,
  'Discovery',
)

const LockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="#F2D72C" className="w-3 h-3">
    <path
      fillRule="evenodd"
      d="M8 1a3.5 3.5 0 0 0-3.5 3.5V7A1.5 1.5 0 0 0 3 8.5v5A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 11.5 7V4.5A3.5 3.5 0 0 0 8 1Zm2 6V4.5a2 2 0 1 0-4 0V7h4Z"
      clipRule="evenodd"
    />
  </svg>
)

const LockWrapper = ({ children, locked }) => (
  <div className="relative">
    {locked && (
      <div className="text-yellow-400 absolute  top-[-3px] left-[-3px]">
        <LockIcon />
      </div>
    )}
    {children}
  </div>
)

const MenuButtons = ({ currentUser }) => {
  const { school } = useSchools()
  const currentPath = window.location.pathname

  const checkIsPremium = (requiresPremium) => (requiresPremium ? school.premium : true)

  return (
    <div className="flex justify-evenly">
      {[
        {
          title: 'Monitoring',
          icon: <MonitorIcon />,
          pathLink: '/dashboard',
        },
      ].map(
        (button) =>
          checkIsPremium(button?.requiresPremium) && (
            <Button
              key={button.title}
              className={clsx(
                currentPath === button.pathLink && '!text-white',
                '!text-xs sm:!text-sm',
              )}
              color="primary"
              startIcon={button.icon}
              onClick={() => navigate(button.pathLink)}
            >
              {button.title}
            </Button>
          ),
      )}
      <Button
        key="Insights"
        className={clsx(
          currentPath ===
            (featureEnabled(currentUser, 'insights_v2')
              ? `/v2/schools/${school.id}/insights`
              : '/dashboard/students/insights') && '!text-white',
          '!text-xs sm:!text-sm',
        )}
        color="primary"
        startIcon={
          <LockWrapper locked={!checkIsPremium(true)}>
            <BarChartIcon />
          </LockWrapper>
        }
        onClick={() =>
          navigate(
            featureEnabled(currentUser, 'insights_v2')
              ? `/v2/schools/${school.id}/insights`
              : '/dashboard/students/insights',
          )
        }
      >
        Insights
      </Button>
      {featureEnabled(currentUser, 'surfacing_students') && (
        <Button
          key="Identification"
          className={clsx(
            currentPath === `/v2/schools/${school.id}/discovery` && '!text-white',
            '!text-xs sm:!text-sm',
          )}
          color="primary"
          startIcon={
            <LockWrapper locked={!checkIsPremium(true)}>
              <DiscoveryIcon />
            </LockWrapper>
          }
          onClick={() => navigate(`/v2/schools/${school.id}/discovery`)}
        >
          Discovery
        </Button>
      )}

      {[
        {
          title: 'Manage',
          icon: <ManageSchoolIcon />,
          pathLink: '/manage-school',
        },
      ].map(
        (button) =>
          checkIsPremium(button?.requiresPremium) && (
            <Button
              key={button.title}
              className={clsx(
                currentPath === button.pathLink && '!text-white',
                '!text-xs sm:!text-sm',
              )}
              color="primary"
              startIcon={button.icon}
              onClick={() => navigate(button.pathLink)}
            >
              {button.title}
            </Button>
          ),
      )}
    </div>
  )
}

export default MenuButtons
